import { useEffect } from "react";
import { RegistrationSteps } from "../../libs/registration/registration-steps";
import { useRegistration } from "../../libs/registration/registration.hook";
import { AppForm } from "../form/styles/app-form";
import { CtaButton } from "../form/styles/cta-button";

let completed = false;

export const SuccessComp = (props: {
  setStep: (step: RegistrationSteps) => void;
}) => {
  const { registrationInfo, completeRegistration } = useRegistration();

  // useEffect(() => {
  //   if (!completed) {
  //     completed = true;
  //     completeRegistration();
  //   }
  // }, []);

  return (
    <AppForm>
      <h2>Thank You</h2>
      <h3>You have completed the registration!</h3>
      {!registrationInfo.pin ? (
        <>
          <p>
            You can also optionally create pin for faster registration in future
          </p>
          <CtaButton onClick={() => props.setStep(RegistrationSteps.AddPin)}>
            Add PIN
          </CtaButton>
        </>
      ) : (
        ""
      )}
    </AppForm>
  );
};
